<ng-helmet>
  <title>{{ 'bookDemoPage.pageTitle' | translate }}</title>
  <meta name="description" [content]="'bookDemoPage.pageDescription' | translate" />
  <meta name="robots" content="noindex, follow" />
</ng-helmet>

<div class="min-h-screen bg-[#061430] relative overflow-hidden flex flex-col">
  <!-- Glow blobs -->
  <div class="absolute -top-[200px] -end-[100px] w-[600px] h-[600px] rounded-full bg-[#353CD8]/[0.35] blur-[120px] pointer-events-none"></div>
  <div class="absolute -bottom-[100px] -start-[80px] w-[400px] h-[400px] rounded-full bg-[#4CEA63]/[0.08] blur-[120px] pointer-events-none"></div>

  <!-- Minimal top bar -->
  <header class="relative z-10 px-6 sm:px-12 py-5 flex items-center justify-between">
    <a routerLink="/" class="shrink-0">
      <img
        src="assets/images/logo_white.svg"
        alt="Uptal"
        class="h-8 w-auto select-none pointer-events-none"
        draggable="false"
      />
    </a>
  </header>

  <!-- Centered content -->
  <main class="relative z-10 flex-1 grid place-items-center px-6 py-12">
    <div class="max-w-xl text-center" data-aos="fade-up">
      <span
        class="inline-flex items-center gap-2 rounded-full border border-[rgba(76,234,99,0.25)] bg-[rgba(42,237,115,0.15)] py-[5px] px-[14px] text-[11px] leading-[18px] font-bold text-[#4CEA63] mb-6"
      >
        <span class="relative flex h-[5px] w-[5px]">
          <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#4CEA63] opacity-75"></span>
          <span class="relative inline-flex rounded-full h-[5px] w-[5px] bg-[#4CEA63]"></span>
        </span>
        {{ 'bookDemoPage.badge' | translate }}
      </span>

      <h1 class="text-[32px] sm:text-[44px] lg:text-[54px] leading-[1.1] font-[900] tracking-[-2px] text-white mb-5">
        {{ 'bookDemoPage.title' | translate }}
      </h1>

      <p class="text-[16px] sm:text-[17px] leading-[28px] text-white/70 mb-10">
        {{ 'bookDemoPage.subtitle' | translate }}
      </p>

      <button
        type="button"
        (click)="openDialog()"
        class="inline-flex items-center justify-center gap-2 rounded-full bg-[#4CEA63] px-8 py-4 text-[15px] font-bold text-[#061430] shadow-[0_4px_16px_0_#4CEA634D] transition-all duration-200 hover:brightness-105"
      >
        {{ 'bookDemoPage.cta' | translate }}
        <span class="rtl:flip inline-grid place-items-center">
          <app-icon name="tabler:arrow-narrow-right" [size]="18" />
        </span>
      </button>
    </div>
  </main>
</div>
